import { ApolloError } from '@apollo/client';
import { IonSpinner, IonText } from '@ionic/react';
import { ReactElement, ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import './graphql.css';

interface LoadingRetryProps {
  loading?: boolean;
  error?: ApolloError;
  results?: {
    hasResults: boolean;
    noResultsComponent: ReactNode;
  };
  refetch?: () => void;
  children: ReactNode;
}

const LoadingRetry = (props: LoadingRetryProps): ReactElement => {
  const { refetch, error, loading, results, children } = props;
  const { i18n } = useTranslation();

  const inner = useMemo(() => {
    if (
      error &&
      !loading &&
      results &&
      results?.hasResults !== true &&
      refetch
    ) {
      return (
        <div className="full-height-width content-center">
          <IonText className="ion-padding ion-text-center" color="medium">
            {i18n.t('common:fetch_error_retry_message')}
            <p />
            <IonText
              className="retry-text"
              onClick={() => refetch()}
              color="primary"
            >
              {i18n.t('common:fetch_retry')}
            </IonText>
          </IonText>
        </div>
      );
    } else if (loading && results && results?.hasResults !== true) {
      return (
        <div className="ion-padding content-center">
          <IonSpinner className="ion-align-self-center" />
        </div>
      );
    } else if (results && results?.hasResults !== true) {
      return <>{results?.noResultsComponent}</>;
    } else {
      return <>{children}</>;
    }
  }, [children, error, loading, refetch, results, i18n]);

  return <>{inner}</>;
};
export { LoadingRetry };
